// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".collapsible{\n  margin-top: 4px;    \n  box-shadow: -1px 1px 5px 1px rgba(0,0,0,0.1)!important;\n  padding: 5px!important;\n}\n\n.collapsible-header{\n  padding: 5px 5px;\n  font-size: 0.9rem;\n  font-weight: 900;\n  color: white;\n  background-color: #bf1f7c;  \n}\n\n.collapsible-body{\n  padding: 0px 0px;\n  border-bottom: unset;\n  margin-top: 8px;\n}\n\n\ntd{\n  padding: 0px!important;\n}\n\n/* \n.chip .close{\n  display: none;\n} */", ""]);
// Exports
module.exports = exports;
